import type { VerificationType } from '@entities/Authentication/types.ts';
import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback } from 'react';
import { type RegistrationMethod } from '@shared/types/common';

type DataT = {
  isOpen: boolean;
  verification_type: VerificationType;
  type?: RegistrationMethod;
  email?: string;
  phonenumber?: string;
  onSuccess?: (captcha?: string) => void;
  onClose?: () => void;
};

export const useCaptchaModal = () => {
  const { data: state, doRemoveStorageData, doSetStorageData } = useSaveData<DataT>('captchaModal');

  const openCaptchaModal = useCallback(
    (props: Omit<DataT, 'isOpen'>) => doSetStorageData({ ...props, isOpen: true }),
    [doSetStorageData]
  );

  const closeCaptchaModal = useCallback(
    ({ isSuccess, captcha }: { isSuccess: boolean; captcha?: string }) => {
      doRemoveStorageData();
      isSuccess && state?.onSuccess && state.onSuccess(captcha);
      state?.onClose && state.onClose();
    },
    [doRemoveStorageData, state]
  );

  return {
    state,
    openCaptchaModal,
    closeCaptchaModal,
  };
};
